import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { CUSTOMER_ORDERS } from '../OrderHistory/OrderHistory.gql';
import OrderPreviewWithData from '../OrderPreview/OrderPreview';
import EmptyOrdersCard from '../EmptyOrdersCard/EmptyOrdersCard';
import { vercel_base_url } from '../../../../util/config';
import { BUILD } from '../../../../util/const';

import * as Styled from './AccountNavOrders.styled';

/**
 * Displays all of the customer's orders in Account Nav Dialog
 */
const AccountNavOrders = ({ onRequestClose, withReactRouter }) => {
  const { error, data, loading } = useQuery(CUSTOMER_ORDERS, {
    context: { service: 'storefront' },
    variables: { limit: 3 }
  });

  if (error) return null;

  const orders = data?.customer?.orders.edges;

  const base_url = BUILD === 'shopify' ? vercel_base_url : '';
  const LinkComponent = BUILD === 'shopify' ? 'a' : Link;

  return (
    <>
      {!!orders?.length && (
        <>
          {orders.map((order, idx) => (
            <OrderPreviewWithData
              key={idx}
              orderId={order.node.id}
              onRequestClose={onRequestClose}
              withReactRouter={withReactRouter}
            />
          ))}
          <Styled.Link
            as={!withReactRouter ? LinkComponent : undefined}
            href={`${base_url}/account/order-history`}
            to="/account/order-history"
            path="/account/order-history"
            onClick={onRequestClose}
          >
            <Styled.ButtonIcon
              variant="default"
              iconPosition="right"
              name="arrow-right"
              iconSize={15}
              isFull
            >
              View All Orders
            </Styled.ButtonIcon>
          </Styled.Link>
        </>
      )}
      {!orders?.length && !loading && <EmptyOrdersCard />}
    </>
  );
};

AccountNavOrders.propTypes = {
  /**
   * A function that is called when `AccountNavDialog` is requesting to close.
   */
  onRequestClose: PropTypes.func.isRequired,
  /**
   * `true` to render react router links
   *  when the component is rendered within a SPA such as Account
   *  otherwise render a normal anchor tag to navigate to the SPA
   */
  withReactRouter: PropTypes.bool
};

AccountNavOrders.defaultProps = {
  withReactRouter: false
};

export default AccountNavOrders;
